import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DomiciliationSubscription from "../../components/Subscriptions/DomiciliationSubscription";
import PlatformGestSubscription from "../../components/Subscriptions/PlatformGestSubscription";
import PlatformAdminSubscription from "../../components/Subscriptions/PlatformAdminSubscription";
import PlatformGRHSubscription from "../../components/Subscriptions/PlatformGRHSubscription";
import PlatformSalesSubscription from "../../components/Subscriptions/PlatformSalesSubscription";
import PlatformJuridiqueSubscription from "../../components/Subscriptions/PlatformJuridiqueSubscription";
import { Container } from "react-bootstrap";

function NewSubscription() {
  const navigate = useNavigate();
  const location = useLocation();
  const { service } = location.state || {};

  if (!service) {
    navigate(-1);
  }
  return (
    <Container fluid style={{ minHeight: "100vh" }}>
      {service === "domiciliation" ? (
        <DomiciliationSubscription from={"newSubscription"} />
      ) : service === "management" ? (
        <PlatformGestSubscription from={"newSubscription"} />
      ) : service === "admin" ? (
        <PlatformAdminSubscription from={"newSubscription"} />
      ) : service === "grh" ? (
        <PlatformGRHSubscription from={"newSubscription"} />
      ) : service === "sales" ? (
        <PlatformSalesSubscription />
      ) : (
        service === "juridique" && (
          <PlatformJuridiqueSubscription from={"newSubscription"} />
        )
      )}
    </Container>
  );
}

export default NewSubscription;
